import { Checkbox } from '../../atoms/checkbox.component';
import { BoolFieldLayout } from '../../layouts/bool-field-layout.component';
import type { BasicBoolFieldProps } from '../../layouts/types';

type Props = BasicBoolFieldProps<'checkbox'> & {
  indeterminate?: boolean;
};

export const CheckboxField = (props: Props) => {
  return <BoolFieldLayout {...props} field={Checkbox} />;
};
